module.exports = __webpack_public_path__ + "img/1481987417.d8b42fc4.jpg";